
    import Vue from 'vue';
    export default {
      scrollToTop: true,
      head() {
        return {
          title: this.title ,
          meta: [{
              hid: 'og:title',
              property: 'og:title',
              content: this.title
            },
            {
              hid: 'twitter:title',
              property: 'twitter:title',
              content: this.title
            },
            {
            hid: 'description',
            name: 'description',
            content:'Explore the full lyrics of Stotra "Bhimrupi Maharudra" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content:'Explore the full lyrics of Stotra "Bhimrupi Maharudra" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content:'Marutistotra, Bhimrupi Maharudra lyrics, Bhimrupi Maharudra lyrics, hanuman stotra, maruti stotra, anjanisuta stotra'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content:'Bhimrupi Maharudra, Marutistotram, Bhimrupi Maharudra lyrics, Bhimrupi Maharudra Marathi lyrics, Bhimrupi Maharudra English lyrics, Maruti Stotra, Hanuman Stotra, Anjanisuta, Ramduta Prabhanjna, devotional stotras, Lord Hanuman prayer, maruti stotra, maruti stotra lyrics, मारुती स्तोत्र मराठी मध्ये, मारुती स्तोत्र भीमरूपी महारुद्रा' 
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/stotra/maruti.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/stotra/maruti.webp'
          },
          ],
        }
      },
    
      components: {
      },
      data() {
        return {
          title: 'Bhimrupi Maharudra | Marutistotra - भीमरूपी महारुद्रा(मारुतिस्तोत्रं)',
          langauageMarathi: true
        }
      },
      layout: 'detailsPage-withoutFooter',
  
      jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/stotra/maruti"
        },
        "headline": "Bhimrupi Maharudra - भीमरूपी महारुद्रा(मारुतिस्तोत्रं)",
        "name" : "Bhimrupi Maharudra - Marutistotra",
        "description": "Explore the full lyrics of stotra 'Bhimrupi Maharudra' in both Marathi and English, with an option to switch between the two languages.",
        "image": this.$config.siteUrl + '/img/stotra/maruti.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },
  
      computed: {
  
      },
      methods:{
        changeLanguage:function () {
          this.langauageMarathi = !this.langauageMarathi
        }
      }
  
    }
  